import React from 'react';
import { styled } from '@mui/system';

const CardSection = styled('div')({
    width: '95%',
    boxShadow: '0px 1px 4px 4px #00000033',
    transition: '0.3s',
    padding: 20,
    borderRadius: 15,
    margin: '10px auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    rowGap: 15,
});

export default CardSection;
